import { MenuItem } from '@material-ui/core';

import { Select, Typography } from '@components';
import { content } from '@content';
import { useStyles } from './StageDropdown.styles';
import { StageDropdownProps } from './StageDropdown.props';

export const StageDropdown = ({ stages, currentStage, onChange, errorMsg }: StageDropdownProps): JSX.Element => {
  const styles = useStyles();

  return (
    <>
      <Typography.Caption component="span" className={styles.caption}>
        {content.cohort}
      </Typography.Caption>
      <Select
        uiType="secondary"
        value={stages.length && currentStage ? currentStage : ''}
        onChange={onChange}
        disabled={!stages.length}
        errorMsg={errorMsg}
      >
        {stages.map((stage: any) => (
          <MenuItem key={stage.id} value={stage.id}>
            {stage.name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
